import 'css-chunk:src/app/components/MemberTable/CustomCells/CheckboxCell/CheckboxCell.scss';export default {
  "checkboxHeaderCell": "_checkboxHeaderCell_th7ht_1",
  "checkboxCell": "_checkboxCell_th7ht_5"
};